import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { finishTask } from '@/api/home';
import { searchRuleList } from '@/api/setting_rule';
import { LocalStorageService } from '@/components/ts/localStorage';
import { USER_INFO } from '@/store/mutation-types';
import { message } from 'ant-design-vue';
import { onMounted, reactive, toRefs } from 'vue'
import { useRoute, useRouter } from 'vue-router';
import {searchOrderList} from "@/api/clinic";
interface FormState {
    ruleName: string,
    description: string,
    scanInterval: number,
    ruleBrand: number,
    ruleType: number,
    id: number,
    ruleOwner: number,
    defaultStatus: number
}


export default /*#__PURE__*/_defineComponent({
  __name: 'fixedAppliance',
  setup(__props) {

const data = reactive<{
    checked: boolean,
    ruleBrand: number,
    dataSource: FormState[],
    oralOrthodonticOrderTrack: any,
    oralDesignOptions:any[]
}>({
    checked: true,
    ruleBrand: 0,
    dataSource: [],
    oralOrthodonticOrderTrack: {
        dentistId: LocalStorageService.get(USER_INFO).id,
        oralDesignId: null,
        patientId: 0,
        wearingCycle: 7,
        startStep: 0,
        stopStep: null,
        switch2d: false,
        switch3d: true
    },
    oralDesignOptions:[]
})
const { oralOrthodonticOrderTrack } = toRefs(data);
let formState = reactive<FormState>({
    ruleName: '自定义',
    description: '',
    scanInterval: 3,
    ruleBrand: 1,
    ruleType: 1,
    id: 0,
    defaultStatus: 0,
    ruleOwner: 0,
})

onMounted(() => {
    init()
})
const init = () => {
    let option = {
        ruleOwner: LocalStorageService.get(USER_INFO).id,
        page: {
            currPage: 1,
            pageSize: 1000,
        },
        ruleBrand: 1
    };
    searchRuleList(option).then((res: any) => {
        if (res.data) {
            data.dataSource = res.data ? res.data : [];
            // data.pagination.total = res ? res.records : 0;
            data.dataSource.push(
                {
                    ruleName: "自定义",
                    id: 0,
                    description: "",
                    scanInterval: 7,
                    ruleBrand: 1,
                    ruleType: 1,
                    ruleOwner: 0,
                    defaultStatus: 0,
                }
            )

            let item = data.dataSource.filter((it: FormState) => it.defaultStatus)
            if (item.length > 0) {
                let row = item[0];
                console.log(row);
                data.ruleBrand = row.id;
                formState.ruleName = row.ruleName;
                formState.description = row.description;
                formState.scanInterval = row.scanInterval;
                formState.ruleBrand = row.ruleType;
                // this.uploadDoctorRule(row)
            } else {
                data.ruleBrand = data.dataSource[data.dataSource.length - 1].id;
                formState.ruleName = "自定义";
                formState.description = "";
                formState.scanInterval = 7;
                formState.ruleBrand = 1;
            }
        }
    });
    searchOrderList(
        {
            patientId: route.query.patientId,
            "page" : {
                "currPage": 1,
                "pageSize": 1000
            },
            status: 3
        }).then((res: any) => {
        data.oralDesignOptions = [];
        if (res.data) {
            data.oralDesignOptions = res.data
        }
    })
}
const handleChange = (value: number) => {
    formState = data.dataSource.filter((item: FormState) => item.id == value)[0]
    formState.scanInterval = 7
    console.log('选择设计订单', value, formState);
}
// 3D开关
const switch3dChange = (checked: boolean) => {
    console.log(checked);
    if (!checked) {
        oralOrthodonticOrderTrack.value.oralDesignId = null
    }
}
const onSubmit = () => {
    if (oralOrthodonticOrderTrack.value.switch3d) {
        if (!oralOrthodonticOrderTrack.value.oralDesignId) {
            message.error('请选择设计订单');
            return
        }
    }
    oralOrthodonticOrderTrack.value.patientId = route.query.patientId;
    let params = {
        monitorRule: {
            ...formState,
        },
        oralOrthodonticOrderTrack: oralOrthodonticOrderTrack.value,
    }
    onFinishTask(params);
}
const route = useRoute();
const router = useRouter();
const onFinishTask = (params: any) => {
    let processDefinitionId = route.query.processDefinitionId;
    let processInstanceId = route.query.processInstanceId;
    let processDefinitionKey = route.query.processDefinitionKey;
    let runTimeTaskId = route.query.runTimeTaskId;
    let taskCode = route.query.taskCode

    let parameters = {
        processDefinitionId: processDefinitionId,
        processInstanceId: processInstanceId,
        processDefinitionKey: processDefinitionKey,
        runTimeTaskId: runTimeTaskId,
        taskCode: taskCode,
        params
    };
    finishTask(parameters).then(() => {
        message.success("操作成功");
        router.push({
            path: "/home",
        });
    });
}

return (_ctx: any,_cache: any) => {
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_form, {
      autocomplete: "off",
      "label-col": { span: 2 },
      "wrapper-col": { span: 16 }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form_item, { label: "3D移动监测" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_switch, {
              checked: _unref(oralOrthodonticOrderTrack).switch3d,
              "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((_unref(oralOrthodonticOrderTrack).switch3d) = $event))
            }, null, 8, ["checked"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, { label: "设计订单" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_select, {
              disabled: !_unref(oralOrthodonticOrderTrack).switch3d,
              value: _unref(oralOrthodonticOrderTrack).oralDesignId,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_unref(oralOrthodonticOrderTrack).oralDesignId) = $event)),
              style: {"width":"200px"},
              options: data.oralDesignOptions,
              "field-names": { label: 'ruleName', value: 'id', options: 'children' },
              onChange: switch3dChange
            }, null, 8, ["disabled", "value", "options"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, { label: "更多设置" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_space, { direction: "vertical" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_space, null, {
                  default: _withCtx(() => [
                    _createTextVNode(" 规则模板: "),
                    _createVNode(_component_a_select, {
                      value: data.ruleBrand,
                      "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((data.ruleBrand) = $event)),
                      style: {"width":"200px"},
                      options: data.dataSource,
                      "field-names": { label: 'ruleName', value: 'id', options: 'children' },
                      onChange: handleChange
                    }, null, 8, ["value", "options"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_space, null, {
                  default: _withCtx(() => [
                    _createTextVNode(" 每隔 "),
                    _createVNode(_component_a_input_number, {
                      min: 1,
                      style: {"width":"80px"},
                      precision: 0,
                      value: _unref(formState).scanInterval,
                      "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_unref(formState).scanInterval) = $event))
                    }, null, 8, ["value"]),
                    _createTextVNode(" 天要求患者扫描一次 ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, { "wrapper-col": { offset: 2, span: 16 } }, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              type: "primary",
              onClick: onSubmit
            }, {
              default: _withCtx(() => [
                _createTextVNode("提交")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})